import React, { useState, useContext } from 'react';
import { useHistory } from "react-router-dom";
import Grid from '@material-ui/core/Grid';
import { Divider, Typography } from '@material-ui/core';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Alert from '@material-ui/lab/Alert';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Fab from '@material-ui/core/Fab';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import { ConvertDateString } from '../../../utils/helpers/dateformat/ConvertDateString'

import Hidden from '@material-ui/core/Hidden';

import { acceptChallenge,getActivityAnswerHistoryById } from '../../../actions/challenge-actions';

import ChallengeContext from '../../../context/challenge-context'
import { BreadcrumbsCustom, Buttons } from '../../shared/component'
import useStyles from '../../../styles/components/learningcontent/stylesLearningContents'
import { Claims } from '../../../utils/services/cache/ClientCache'

import SunEditor,{buttonList} from "suneditor-react";
import align from 'suneditor/src/plugins/submenu/align'
import blockquote from 'suneditor/src/plugins/command/blockquote'
import font from'suneditor/src/plugins/submenu/font'
import fontColor from 'suneditor/src/plugins/submenu/fontColor'
import fontSize from 'suneditor/src/plugins/submenu/fontSize'
import formatBlock from 'suneditor/src/plugins/submenu/formatBlock'
import hiliteColor from 'suneditor/src/plugins/submenu/hiliteColor'
import horizontalRule from 'suneditor/src/plugins/submenu/horizontalRule'
import lineHeight from 'suneditor/src/plugins/submenu/lineHeight'
import list from 'suneditor/src/plugins/submenu/list'
import table from 'suneditor/src/plugins/submenu/table'
import textStyle from 'suneditor/src/plugins/submenu/textStyle'
import paragraphStyle from 'suneditor/src/plugins/submenu/paragraphStyle';
import 'suneditor/dist/css/suneditor.min.css';

const Activities = () => {

    const history = useHistory();
    const classes = useStyles();
    const { challengeContext, dispatch } = useContext(ChallengeContext);
    const [answerHistories,setAnswerHistories] = useState([]);
    const [answerHistoryDialogFlag, setAnswerHistoryDialogFlag] = useState(false);
    const [answerHistoryDialogTitle, setAnswerHistoryDialogTitle] = useState("");
    const [activityDetail, setActivityDetail] = useState({ open: false, challengeId: 0, activityId: 0, memberId: 0 });

    const breadcrumbsData = [
        {
            text: 'Challenge',
            href: '/Challenge'
        },
        {
            text: 'Activities',
            href: ''
        },
    ];

    function checkMember(member) {
        return member.StudentNumber.toLowerCase() === Claims.getGivenName().toLowerCase();
    }

    const handleStartChallenge = async () => {
        let memberId = retrieveMemberId()
        let data = {
            MemberId: memberId,
            ChallengeId: challengeContext.challenge.ChallengeId
        }

        let response = await acceptChallenge(JSON.stringify(data));
        if (response > 200 || response.status === "Failed") {
            alert("Something went wrong!");
        }
        if (response.status === "Success") {
            //console.log("ChallengeActivityViewModels", response.data);
            let index = challengeContext.challenge.TeamMemberViewModels.findIndex(checkMember);
            challengeContext.challenge.TeamMemberViewModels[index].Status = "Accepted";
            challengeContext.challenge.ChallengeActivityViewModels = response.data;
            dispatch({ type: 'SET_CHALLENGE', challenge: challengeContext.challenge });
        }
    }

    const retrieveMemberId = ()=>{
        let member = challengeContext.challenge.TeamMemberViewModels.find((member) => {
            if (member.StudentNumber.toLowerCase() === Claims.getGivenName().toLowerCase())
                return member;
        });
        return member.MemberId;
    }

    const handleOpenAnswersHistory = async (activityId,activityTitle)=>{
        let memberId = retrieveMemberId();
        // console.log(activityId + " : " + memberId);
        let response = await getActivityAnswerHistoryById(memberId,activityId);
        setAnswerHistoryDialogFlag(true);
        setAnswerHistoryDialogTitle(activityTitle);
        setAnswerHistories(response.data);
        // console.log(response);
    }
    const handleCloseAnswersHistory = () =>{
        setAnswerHistoryDialogFlag(false);
        setAnswerHistories([]);
        setAnswerHistoryDialogTitle("");
    }

    const signUpDialogOpen = () => {
        challengeContext.signUpForm.challengeId = challengeContext.challenge.ChallengeId;
        challengeContext.signUpForm.teamMembers[0].studentNumber = Claims.getGivenName();
        challengeContext.signUpForm.teamMembers[0].isLeader = true;
        dispatch({ type: 'SET_SIGNUPFORM', signUpForm: challengeContext.signUpForm });

        challengeContext.dialogs.signUpDialog = true;
        dispatch({ type: 'SET_DIALOGS', dialogs: challengeContext.dialogs });
    }

    const gotoActivityDetail = (activityId) => {
        let member = challengeContext.challenge.TeamMemberViewModels.find((member) => {
            if (member.StudentNumber.toLowerCase() === Claims.getGivenName().toLowerCase())
                return member;
        });

        setActivityDetail({
            open: true,
            challengeId: challengeContext.challenge.ChallengeId,
            activityId: activityId,
            memberId: member.MemberId
        })
    }

    function secondsToHms(d) {
        d = Number(d);
        let h = Math.floor(d / 3600);
        let m = Math.floor(d % 3600 / 60);
        let s = Math.floor(d % 3600 % 60);

        let hDisplay = h > 0 ? h + (h == 1 ? " hour, " : " hours, ") : "";
        let mDisplay = m > 0 ? m + (m == 1 ? " min, " : " mins, ") : "";
        let sDisplay = s > 0 ? s + (s == 1 ? " sec" : " secs") : "";
        let time = hDisplay + mDisplay + sDisplay;
        time = time.length > 0 ? time : "NA"
        return time;

        //let hDisplay = h > 0 ? h + (":") : "00:";
        //let mDisplay = m > 0 ? m + (":") : "00:";
        //let sDisplay = s > 0 ? s : "00";
    }

    const handleClose = () => {
        setActivityDetail({ open: false, challengeId: 0, activityId: 0, challengeId: 0 })
    }

    const handleOk = () => {
        history.push(`/Activity/${activityDetail.challengeId}/${activityDetail.activityId}/${activityDetail.memberId}`)
    }

    const handleClickTabs = (item) => {
        switch (item) {
            case "overview":
                challengeContext.tabs.overview = true;
                challengeContext.tabs.teamMember = false;
                challengeContext.tabs.activities = false;
                challengeContext.tabs.leaderboard = false;
                dispatch({ type: 'SET_TABS', tabs: challengeContext.tabs });
                break;
        }
    }

    return (
        <>
            <BreadcrumbsCustom breadcrumbsData={breadcrumbsData} />
            <Grid classes={{ root: classes.rootGridDescription }}>
                <Typography style={{ fontSize: '20px', fontWeight: 'bold' }}>Activities</Typography>
            </Grid>
            {
                challengeContext.challenge.IsSignedUp ?
                    challengeContext.challenge.ChallengeActivityViewModels.length > 0 ?
                        <TableContainer component={Paper}>
                            <Table>
                                <TableHead>
                                    <TableRow style={{ backgroundColor: '#0C8FAD' }}>
                                        <TableCell align="center" style={{ fontSize: '16px', fontWeight: 'bold', color: 'white' }}>Activity Title</TableCell>
                                        <TableCell align = "center" style={{ fontSize: '16px', fontWeight: 'bold', color: 'white' }}>Team Activity?</TableCell>
                                        <TableCell align="center" style={{ fontSize: '16px', fontWeight: 'bold', color: 'white' }}>Time Taken</TableCell>
                                        <TableCell align="center" style={{ fontSize: '16px', fontWeight: 'bold', color: 'white' }}>Score</TableCell>
                                        <TableCell align="center" style={{ fontSize: '16px', fontWeight: 'bold', color: 'white' }}>Completed?</TableCell>
                                        <TableCell colSpan={2} align="center" style={{ fontSize: '16px', fontWeight: 'bold', color: 'white' }}>Actions</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {challengeContext.challenge.ChallengeActivityViewModels.map((row) => (
                                        <TableRow key={row.ActivityId}>
                                            <TableCell align="center">{row.ActivityTitle}</TableCell>
                                            <TableCell align = "center">{row.IsTeamActivity ? "Yes" : "No"}</TableCell>
                                            <TableCell align="center">{secondsToHms(row.TimeTaken)}</TableCell>
                                            <TableCell align="center">{row.Score}</TableCell>
                                            <TableCell align="center">{row.IsCompleted ? "Yes" : "No"}</TableCell>
                                            <TableCell align="center"> 
                                                {
                                                    row.IsCompleted 
                                                    ?
                                                    <span style = {{fontSize:'18px',textTransform: 'capitalize',color:'#4DD091', fontFamily:'Roboto-Regular',}}>Completed</span>
                                                        :
                                                        row.IsPendingMarking
                                                    ?
                                                        <span style = {{fontSize:'18px',textTransform: 'capitalize',color:'#ff7e00', fontFamily:'Roboto-Regular',}}>Pending</span>
                                                        :
                                                        <Buttons text="View Activity" onClick={() => gotoActivityDetail(row.ActivityId)} /> //Info
                                                }
                                            </TableCell>
                                            <TableCell align = "center"><Buttons text = "Submitted Answers" onClick = {()=>handleOpenAnswersHistory(row.ActivityId,row.ActivityTitle)}/></TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                        :
                        <Alert variant="outlined" severity="info" style={{ fontSize: '16px' }}>
                            You can start browsing the activities by clicking <a className="button one" onClick={() => handleStartChallenge()}>Here</a>
                        </Alert>
                    :
                    <Alert variant="outlined" severity="info" style={{ fontSize: '16px' }}>
                        You do not have a team for this challenge. Click <a className="button one" onClick={() => signUpDialogOpen()}>Here</a> to participate in this challenge.
                    </Alert>
            }

            <Hidden lgUp>
                <Fab onClick={() => handleClickTabs("overview")} color="secondary" style={{ position: "fixed", bottom: '5px', right: '5px', margin: '5px' }}>
                    <ArrowBackIcon />
                </Fab>
            </Hidden>
            {/* <ViewCurrentAnswersDialog 
                _answerHistoryDialogFlag = {answerHistoryDialogFlag}
                _handleCloseAnswersHistory = {handleCloseAnswersHistory}
                maxWidth = {false}
                fullWidth = {true}
                _answerHistories = {answerHistories}
                _answerHistoryDialogTitle = {answerHistoryDialogTitle}
            >
            <ViewCurrentAnswersDialog/> */}
            

            <Dialog
                open = {answerHistoryDialogFlag}
                onClose = {handleCloseAnswersHistory}
                maxWidth = {'lg'}
                fullWidth = {true}
            >
                <DialogTitle id="alert-dialog-title" className="idletimeoutmodal__dialog__title">
                    <div className="adventurelearn__header">Viewing answers for activity {answerHistoryDialogTitle}</div>
                </DialogTitle>
                <DialogContent dividers = {true}>
                    {answerHistories.length > 0 ? 
                        <Grid container classes={{ root: classes.assessmentBox }}>
                        <List>
                            {answerHistories.map((item,index)=>(
                                <Grid container alignItems ={"flex-start"} key = {index} classes = {{root: classes.assessmentBox}}>
                                    <Grid item xs = {12} sm = {12}>
                                        <Typography classes={{ root: classes.rootTitle }}>Question: {item.QuestionContent}</Typography>
                                    </Grid>
                                    <Grid item xs = {12} sm = {12}>
                                        <Typography classes={{ root: classes.rootTitle }}>Submitted By: {item.SubmittedBy}</Typography>
                                    </Grid>
                                    <Grid item xs = {12} sm = {12}>
                                        <Typography classes = {{root: classes.rootTitle}}>Date Submitted: {item.DateSubmitted}</Typography>
                                    </Grid>
                                    <Grid item xs = {12} sm = {12}>
                                        <Typography classes = {{root: classes.rootTitle}}>Score Given:&nbsp; 
                                            {item.Score < 1 ? item.IsMarked ? <span style = {{color:"#da291c"}}>{item.Score}&nbsp;(Marked)</span> : <span style = {{color:"#FFA500"}}>{item.Score}&nbsp;(Pending)</span> : <span style = {{color:"#4DD091"}}>{item.Score}&nbsp;</span>}
                                        </Typography> 
                                    </Grid>
                                    <Grid item>
                                        <Typography classes={{ root: classes.rootTitle }}>Answer: </Typography>
                                        <SunEditor
                                            showToolbar={false}
                                            enableToolbar={false}
                                            disable={true}
                                            setOptions={{
                                                height: 'auto',
                                                minHeight: '100px',
                                                maxHeight: '200px',
                                                width:"auto",
                                                minWidth:'400px',
                                                maxWidth:'600px',
                                                resizingBar: false,
                                            }}
                                            toggleFullScreen={true}
                                            setContents = {item.Answer}
                                            showController={false}
                                        />
                                    </Grid>
                                    <Grid item>               
                                        <Typography classes={{ root: classes.rootTitle }}>Feedback: </Typography>                 
                                        <SunEditor
                                                showToolbar={false}
                                                enableToolbar={false}
                                                disable={true}
                                                setOptions={{
                                                    height: 'auto',
                                                    minHeight: '100px',
                                                    maxHeight: '200px',
                                                    width:"auto",
                                                    minWidth:'400px',
                                                    maxWidth:'600px',
                                                    resizingBar: false,
                                                }}
                                                toggleFullScreen={true}
                                                setContents = {item.Remarks}
                                                showController={false}
                                        />
                                    </Grid>
                                </Grid>
                            )) }
                        </List>
                        </Grid>
                    :
                        <Grid container>No free response answers have been submitted yet or activity does not contain any free response assessment.</Grid>
                    }

                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseAnswersHistory} className="adventurelearn__dialogOk">
                        Close
                    </Button>
                </DialogActions>
            </Dialog>
            
            <Dialog
                open={activityDetail.open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description">
                <DialogTitle id="alert-dialog-title" className="idletimeoutmodal__dialog__title">
                    <div className="adventurelearn__header">Instructions</div>
                </DialogTitle>
                <DialogContent style={{ marginTop: '10px' }}>
                    <Alert variant="outlined" severity="info" style={{ fontSize: '16px' }}>
                        <b>Please kindly read the instructions before attempting the activity.</b>
                        <div>
                            <List>
                                <ListItem>
                                    <ListItemText
                                        primary="#1 You are not allowed to click back or reload once you click 'Acknowledge'."
                                    />
                                </ListItem>
                                <ListItem>
                                    <ListItemText
                                        primary="#2 The system will track the time once you click 'Acknowledge'."
                                    />
                                </ListItem>
                                <ListItem>
                                    <ListItemText
                                        primary="#3 Your score will be calculated based on the correct answers."
                                    />
                                </ListItem>
                            </List>
                        </div>
                    </Alert>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleOk} className="adventurelearn__dialogOk">
                        Acknowledge
                    </Button>
                    <Button onClick={handleClose} className="adventurelearn__dialogCancel">
                        Cancel
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};

export default Activities;